import { useState } from 'react';

import { rating_classification } from 'utils/getRatingClassification';

import * as S from './styles';

interface EvaluateProps {
  productEvaluation: number;
  setProductEvaluation: (star: number) => void;
}

export function Evaluate({
  productEvaluation,
  setProductEvaluation,
}: EvaluateProps) {
  const [indexStar, setIndexStar] = useState(0);

  const productRating = rating_classification[0]?.stars.map(star => star);

  return (
    <S.Container className="evaluate">
      <div className="stars">
        {productRating.map((star, index) => {
          const hovered =
            indexStar !== null ? indexStar > index : productEvaluation > index;

          return (
            <img
              src={
                hovered ? 'images/icons/star.png' : 'images/icons/reg-star.png'
              }
              alt="Estrela"
              className="icon regStar-icon"
              onMouseEnter={() => {
                setIndexStar(index + 1);
              }}
              onMouseOut={() => setIndexStar(productEvaluation)}
              onClick={() => setProductEvaluation(index + 1)}
              key={index}
            />
          );
        })}
      </div>
    </S.Container>
  );
}
